document.documentElement.classList.remove('no-js');

function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-menu-open]');
  const panel = document.querySelector('[data-mobile-panel]');
  if (!toggle || !panel) return;

  const openMenu = () => {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('bps-menu-open');
  };

  const closeMenu = () => {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('bps-menu-open');
  };

  toggle.addEventListener('click', openMenu);
  panel.querySelectorAll('[data-mobile-menu-close], a').forEach((element) => {
    element.addEventListener('click', closeMenu);
  });
  panel.addEventListener('click', (event) => {
    if (event.target === panel) closeMenu();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
}

function initServiceAreaCheckers() {
  const toRadians = (value) => (Number(value) * Math.PI) / 180;
  const milesBetween = (lat1, lon1, lat2, lon2) => {
    const earthRadiusMiles = 3958.7613;
    const latitudeDifference = toRadians(lat2 - lat1);
    const longitudeDifference = toRadians(lon2 - lon1);
    const calculation =
      Math.sin(latitudeDifference / 2) ** 2 +
      Math.cos(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.sin(longitudeDifference / 2) ** 2;
    return earthRadiusMiles * 2 * Math.atan2(Math.sqrt(calculation), Math.sqrt(1 - calculation));
  };

  document.querySelectorAll('[data-bps-service-area]').forEach((section) => {
    const token = section.dataset.mapboxToken || '';
    const centerLatitude = Number(section.dataset.centerLat);
    const centerLongitude = Number(section.dataset.centerLon);
    const radius = Number(section.dataset.radius || 15);
    const input = section.querySelector('[data-service-address]');
    const button = section.querySelector('[data-service-check]');
    const result = section.querySelector('[data-service-result]');
    const createAccount = section.querySelector('[data-service-create]');
    if (!input || !button || !result) return;

    button.addEventListener('click', async () => {
      const query = input.value.trim();
      if (!query) {
        result.innerHTML = '<span class="bps-service-result__error">Enter the address where pet care will take place.</span>';
        if (createAccount && token) createAccount.hidden = true;
        return;
      }

      if (!token) {
        result.innerHTML = '<span class="bps-service-result__neutral">Automatic checking is not connected yet. Continue to registration; your address will be reviewed before booking is activated.</span>';
        if (createAccount) createAccount.hidden = false;
        return;
      }

      button.disabled = true;
      button.textContent = 'Checking…';

      try {
        const proximity = `${centerLongitude},${centerLatitude}`;
        const endpoint = `https://api.mapbox.com/search/geocode/v6/forward?q=${encodeURIComponent(query)}&country=US&limit=1&proximity=${encodeURIComponent(proximity)}&access_token=${encodeURIComponent(token)}`;
        const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Address service unavailable');

        const data = await response.json();
        const feature = data.features && data.features[0];
        const coordinates = feature?.geometry?.coordinates;
        if (!coordinates) throw new Error('Address not found');

        const distance = milesBetween(
          centerLatitude,
          centerLongitude,
          Number(coordinates[1]),
          Number(coordinates[0])
        );
        const label = feature.properties?.full_address || feature.properties?.name || query;

        if (distance <= radius) {
          result.innerHTML = `<span class="bps-service-result__success">Good news—${label} is approximately ${distance.toFixed(1)} miles from downtown and is inside the ${radius}-mile service area.</span>`;
          if (createAccount) createAccount.hidden = false;
        } else {
          result.innerHTML = `<span class="bps-service-result__error">This address is approximately ${distance.toFixed(1)} miles from downtown, outside the current ${radius}-mile service area. Contact us before creating an account.</span>`;
          if (createAccount) createAccount.hidden = true;
        }
      } catch (error) {
        result.innerHTML = '<span class="bps-service-result__error">We could not verify that address. Check the spelling or contact us for a manual service-area check.</span>';
        if (createAccount) createAccount.hidden = true;
      } finally {
        button.disabled = false;
        button.textContent = 'Check address';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initServiceAreaCheckers();
});
